import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2mvdyzg3tq: FaireBrandEntity = {
  token: "b_2mvdyzg3tq",
  type: "brand",
  name: "Olivaceous",
  avatarUrl:
    "https://cdn.faire.com/fastly/39832fb751a8b167f45c296f56a486b1e713c25dc5a7f11f4d976a710d6516fd.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/8ddbe9916f92f551c4b5b5e21fa73a7d2d6560a670cdd8bbb7ed667d19279134.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/39832fb751a8b167f45c296f56a486b1e713c25dc5a7f11f4d976a710d6516fd.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8ddbe9916f92f551c4b5b5e21fa73a7d2d6560a670cdd8bbb7ed667d19279134.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 150,
  rating: 4.7,
  reviewCount: 133,
  isInsider: true,
  description:
    "Olivaceous is a young contemporary wholesale clothing brand located in Downtown Los Angeles. We pride ourselves in being a women-led company that draws inspiration from cool, classic, and confident individuals. The Olivaceous girl isn't afraid to be the life of the party, leave a lasting impression, and set daring trends. Our vision is to create unique silhouettes and fun everyday wear so that our girl will have heads turning all season 'round.",
  meta: {
    source: "api",
    importedAt: "2026-08-18T16:18:14.829Z",
    importedBy: "entity-db-cli",
  },
};
